module.exports = __webpack_public_path__ + "static/media/1443603138(2).493ab07f.jpg";